import { PREVENT_NAVIGATION_MODAL_SYMBOL_NAME } from 'containers/PreventNavigationModal/PREVENT_NAVIGATION_MODAL'
import {createBrowserHistory} from 'history'

export default createBrowserHistory(
  {
    getUserConfirmation (message, callback) {
      window[Symbol.for(PREVENT_NAVIGATION_MODAL_SYMBOL_NAME)]
        .showModal(message, callback)
    }
  })
